export enum AuthRoutes {
  statements = '/statements',
  evaluations = '/evaluations',
  utils = '/utils',
  profile = '/profile',
}
